import { render, staticRenderFns } from "./api_errors.vue?vue&type=template&id=451807a0&scoped=true&"
import script from "./api_errors.vue?vue&type=script&setup=true&lang=ts&"
export * from "./api_errors.vue?vue&type=script&setup=true&lang=ts&"
import style0 from "./api_errors.vue?vue&type=style&index=0&id=451807a0&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "451807a0",
  null
  
)

export default component.exports